import { Flow } from 'vexflow';

const initialized = false;
export function initializeVexFont() {
  if (!initialized) {
    Flow.setMusicFont('Gonville', 'Bravura');
  }
}
